<template>
  <div
    ref="homeBox"
    class="homeBox index-search"
    v-loading="loading"
    @scroll.passive="handleScroll"
  >
    <button @click="changePage">切换</button>
    <el-radio-group
      v-model="searchQuery.isComplete"
      @change="handleClick"
      style="display:flex;padding-left:105px;margin:5px 0 24px 0;"
      class="index-search-radio"
    >
      <el-radio-button :label="0" class="index-search-radio-item">
        执行中项目
      </el-radio-button>
      <el-radio-button :label="1">已完结项目</el-radio-button>
    </el-radio-group>
    <div class="searchBox">
      <div>
        <label>服务项目</label>
        <dic-select
          @dic-select-obj="saveProId"
          :fuzzyDef="searchAjax"
          :prop="prop"
          placeholder="请选择"
          ajaxQuery="demandProjectName"
          style="width:160px;"
          :ifClear="true"
        ></dic-select>
      </div>
      <div>
        <label>服务子项</label>
        <dic-select
          @dic-select-obj="saveProId2"
          :ajaxQueryObj="parentObj"
          :fuzzyDef="searchAjax"
          :prop="prop"
          :setEmpty="empty"
          :isDisabled="!searchQuery.demandProjectId"
          placeholder="请选择"
          ajaxQuery="demandProjectName"
          style="width:160px;"
          :ifClear="true"
        ></dic-select>
      </div>
      <div>
        <label>下游企业</label>
        <dic-select
          @dic-select-obj="saveProId3"
          :fuzzyDef="searchAjax2"
          :prop="prop2"
          placeholder="请选择"
          ajaxQuery="csoEnterpriseName"
          style="width:160px;"
          :ifClear="true"
        ></dic-select>
      </div>
      <div v-if="isMaster">
        <label>子账号</label>
        <dic-select
          @dic-select-obj="
            val => {
              searchQuery.subAccountUserId = val.userId;
            }
          "
          :fuzzyDef="selectOptions"
          :prop="{
            label: 'userName',
            code: 'userId'
          }"
          placeholder="请选择"
          ajaxQuery="userName"
          style="width:160px;"
          :ifClear="true"
        ></dic-select>
      </div>

      <div>
        <el-input
          v-model="searchQuery.projectName"
          placeholder="请输入项目名称"
          style="width:220px;"
          clearable
        ></el-input>
      </div>
      <div class="search-right">
        <el-button type="primary" @click="searchEvent">搜索</el-button>
        <el-button
          type="primary"
          @click="batchConfirmProject"
          :disabled="chooseProjectList.length == 0"
        >
          确认项目信息
        </el-button>
      </div>
    </div>
    <pro-list
      v-if="projectList.length > 0"
      ref="proList"
      v-loading="loading"
      style="position:relative;"
    >
      <checkAllForProjectConfirm
        style="position:absolute;top:0;right:0;z-index: 2;"
        :projectList="projectList"
        :chooseProjectList="chooseProjectList"
        @chooseAll="
          list => {
            chooseProjectList = list;
          }
        "
      ></checkAllForProjectConfirm>
      <pro-group v-for="(item, i) in projectList" :key="i" :data="item">
        <pro-list-item
          v-for="item_c in item.list"
          :data="item_c"
          :key="item_c.id"
          :id="`project-${item.id}`"
          :offsetY="offsetY"
          :container="$refs.homeBox"
          :isChoosed="chooseProjectList.includes(+item_c.id)"
          @choose="
            id => {
              const index = chooseProjectList.findIndex(i => i == id);
              if (index > -1) {
                chooseProjectList.splice(index, 1);
              } else {
                chooseProjectList.push(id);
              }
            }
          "
          @jump="jump(item_c)"
          @jumpOrder="jumpOrder(item_c)"
          @powerMgmt="powerMgmt(item_c)"
        ></pro-list-item>
      </pro-group>
    </pro-list>
    <img
      src="http://yiyang.oss-cn-beijing.aliyuncs.com/WEB/sass/img/missing"
      class="missing"
      v-else
    />
  </div>
</template>

<script>
import { btLoading } from '@/Mixin/btLoading';
import { project, subAccount, batchConfirmProject } from '@/api/ajax';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { businessType, projectAllList } from '@/config/staticData';
import proList from './components/project-list';
import proGroup from './components/project-group';
import proListItem from './components/project-list-item';
import createExtend from '@/components/createExtend.js';
import debounce from 'lodash.debounce';
import subAccountMgmt from '@/page/home/child/subAccountMgmt';
import { setStorage } from '@/tools/storage';
import checkAllForProjectConfirm from './components/checkAllForProjectConfirm.vue';

const lazyLoad = (items, type) => {
  let len = items.length;
  while (len > 0) {
    items[len - 1].setVisible && items[len - 1].setVisible(type);
    len--;
  }
};
export default {
  name: 'homePage',
  mixins: [btLoading],
  data() {
    return {
      // 公司类型
      businessType,
      // 项目列表
      projectList: [],
      searchQuery: {
        businessType: '',
        projectName: '',
        isComplete: 0,
        demandProjectId: '',
        demandSonProjectId: '',
        projectEnterpriseName: '',
        csoEnterpriseId: '',
        subAccountUserId: ''
      },
      loading: true,
      searchAjax: project.demandProjectList,
      searchAjax2: project.obtainCsoEnterprise,
      selectOptions: subAccount.selectOptions,
      prop: {
        label: 'projectName',
        code: 'id'
      },
      prop2: {
        label: 'enterpriseName',
        code: 'id'
      },
      empty: 0,
      offsetY: 0,
      subAccountUserId: '',
      chooseProjectList: []
    };
  },
  components: {
    dicSelect: () => import('@/components/Common/dicSelect.vue'),
    checkAllForProjectConfirm,
    proList,
    proGroup,
    proListItem
  },
  methods: {
    ...mapActions(['setHomeQuery', 'setActivename']),
    ...mapMutations(['CLEAN_HOME']),
    handleScroll(e) {
      // ~debounce(() => {
      //   // window.requestAnimationFrame(() => {
      //   this.offsetY =
      //     e.target.scrollTop || window.pageYOffset || document.body.scrollTop;
      //   // });
      //   this.computedVisible();
      // }, 200)();
    },
    computedVisible(type) {
      return;
      if (!this.$refs.proList) return;
      let lazyItems = this.$refs.proList.$children;
      lazyItems.forEach((ele, i) => {
        lazyLoad(lazyItems[i].$children, type);
      });
    },
    saveProId(val) {
      this.searchQuery.demandProjectId = val.id;
    },
    saveProId2(val) {
      this.searchQuery.demandSonProjectId = val.id;
    },
    saveProId3(val) {
      this.searchQuery.csoEnterpriseId = val.id;
    },
    handleClick() {
      this.setActivename(this.searchQuery.isComplete);
      this.searchEvent();
    },
    jump(item) {
      localStorage.projectType = item.projectType; //projectType 1病例 2学术拜访 3otc 4hjh 5ksh 6调查问卷 7ysh调查问卷   1学术拜访  2 OTC巡访  3 科室会  4 患教会 5病例 6ysh调查问卷 7助手调查问卷
      setStorage('home-search-query', this.searchQuery);
      this.setHomeQuery(item).then(res => {
        this.$router.push({
          path: '/edit/index',
          query: {
            id: item.id
          }
        });
      });
    },
    // 跳转到订单详情
    jumpOrder(item) {
      // TODO 确认这一步是干什么的 this.saveHistory(item);
      const orderPath = '/projectSettled/list';
      const routeDate = this.$router.resolve({
        path: orderPath,
        query: {
          projectId: item.id,
          projectName: item.projectName
        }
      });

      window.open(routeDate.href, '_blank');
    },
    // 权限管理
    powerMgmt(item) {
      createExtend(subAccountMgmt, {
        data: item
      }).$on('updated', () => {
        this.searchEvent();
        this.$nextTick(() => {
          this.computedVisible();
        });
      });
    },
    searchEvent() {
      this.loading = true;
      project
        .selectProjectList({
          ...this.searchQuery,
          projectStructureType: this.projectStructureType
        })
        .then(res => {
          this.projectList = res.data.data;
          this.loading = false;
        });
    },
    getList() {
      project
        .selectProjectList({
          projectStructureType: this.projectStructureType
        })
        .then(res => {
          this.projectList = res.data.data;
          this.loading = false;
        });
    },
    batchConfirmProject() {
      if (this.chooseProjectList.length == 0) {
        return;
      }
      this.$xrkDialog({
        title: '确认项目',
        width: '400px',
        showCancel: true,
        showConfirm: true,
        confirmText: '确认',
        success: params => {
          if (params.confirm) {
            batchConfirmProject({
              projectIds: this.chooseProjectList.join(',')
            })
              .then(({ data: { data, status } }) => {
                if (status == 1) {
                  this.$message.success('提交成功');
                  this.chooseProjectList = [];
                  this.searchEvent();
                } else {
                  this.$alert(data);
                }
                params.dialog.remove();
              })
              .catch(() => {
                this.$message.error('提交失败，稍后再试');
              });
          }
        },
        $slots: {
          default: this.$createElement(
            'div',
            {
              style: {
                marginTop: '10px',
                textAlign: 'center',
                fontSize: '16px',
                color: '#4A4A4A'
              }
            },
            '是否确认提交项目信息'
          )
        }
      });
    },
    changePage() {
      this.$router.push({
        name: 'v3-questionnaire-list'
      });
    }
  },
  created() {
    this.CLEAN_HOME();
    this.getList();
  },
  filters: {
    transType(v, item) {
      return item.projectType == 20
        ? item.serviceSubitem
        : projectAllList[v - 1].name;
    }
  },
  watch: {
    'searchQuery.demandProjectId': {
      handler(v) {
        this.empty += 1;
        this.searchQuery.demandSonProjectId = '';
      }
    }
  },
  computed: {
    ...mapGetters(['isMaster']),
    parentObj() {
      return {
        demandProjectId: this.searchQuery.demandProjectId
      };
    },
    ...mapState({
      activeName: state => state.homeProject.activeName
    })
  },
  mounted() {
    // window.addEventListener(
    //   'resize',
    //   debounce(() => {
    //     this.computedVisible('resize');
    //   }, 100)
    // );
    let scrollWrap = document.querySelector('.el-main');
    scrollWrap && (scrollWrap.style.padding = '0');
  },
  destroyed() {
    window.removeEventListener(
      'resize',
      debounce(() => {
        this.computedVisible('resize');
      }, 100)
    );
    let scrollWrap = document.querySelector('.el-main');
    scrollWrap && (scrollWrap.style.padding = '20');
  }
};
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixins.scss';
@import '~@/styles/theme.scss';

.homeBox {
  width: 100%;
  height: calc(100vh - 150px);
  display: inline-block;
  overflow-y: scroll;
}

::v-deep .index-search {
  &-radio {
    .el-radio-button {
      &:first-child {
        .el-radio-button__inner {
          border-right-width: 0 !important;
          border-radius: 0;
          border-top-left-radius: 8px;
        }
      }
      &:last-child {
        .el-radio-button__inner {
          border-right-width: 2px !important;
          border-radius: 0;
          border-top-right-radius: 8px;
        }
      }
      .el-radio-button__inner {
        border: 2px solid $--color-primary !important;
      }
      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        border-color: $--color-primary;
        background-color: $--color-primary;
      }
    }
  }
}
.searchBox {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  background: #fff;
  padding: 24px 0 14px 105px;
  margin-bottom: 20px;
  > div {
    display: flex;
    align-items: center;
    margin-right: 40px;
    margin-bottom: 10px;
    label {
      font-size: 14px;
      font-weight: bold;
      margin-right: 15px;
    }
  }
}
.homeUl {
  padding: 0 105px;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  height: 100%;
  justify-content: flex-start;
  padding-top: 30px;
  li {
    position: relative;
    cursor: pointer;
    width: 23%;
    margin: 0 1%;
    margin-bottom: 4.4vh;
    border-radius: 12px;
    border: 2px solid transparent;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: middle;
    -webkit-transform: perspective(1px) translateZ(0);
    transform: perspective(1px) translateZ(0);
    box-shadow: 0 0 1px rgba(0, 0, 0, 0);
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -webkit-transition-property: box-shadow, transform;
    transition-property: box-shadow, transform;
    img {
      width: 100% !important;
      height: auto !important;
      border-radius: 12px 12px 0 0;
    }
  }
}
.missing {
  width: auto;
  height: auto;
}
li:hover {
  box-shadow: 0 20px 20px -20px rgba(0, 0, 0, 0.5);
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
li:nth-of-type(4n + 4) {
  margin-right: 0;
}
.textBox {
  padding-left: 15px;
  padding-bottom: 2px;
  box-shadow: 1px 0px 50px 2px #e5e5e5;
  border-radius: 0 0 12px 12px;
  div {
    text-align: left;
    font-size: 1em;
    color: #666;
    line-height: 1.1;
    margin-bottom: 0.6vw;
  }
  .projectName {
    font-size: 1.4em;
    color: #1989fa;
    line-height: 2.4em;
    margin-bottom: 0;
  }
  .one-line {
    @include textOverflow();
  }
}

.unPublish {
  position: absolute;
  top: 1.04vw;
  right: 1.04vw;
  width: 4.58vw;
  height: 1.56vw;
  line-height: 1.56vw;
  font-size: 1em;
  border-radius: 0.78vw;
  background: #de532d;
  color: #fff;
}
.published {
  position: absolute;
  top: 1.04vw;
  right: 1.04vw;
  width: 4.58vw;
  height: 1.56vw;
  line-height: 1.56vw;
  font-size: 1em;
  border-radius: 0.78vw;
  background: #4cd996;
  color: #fff;
}
.tabBox {
  margin-left: 5%;
  margin-bottom: 20px;
}
</style>
